import {Component, Input, OnChanges, SimpleChange, ViewChild} from "@angular/core";
import {Determinant} from "../../../../../../models/determinant";

@Component({
  selector: "related-determinant-set",
  templateUrl: "./related-determinant-set.component.html",
  styles: [],
})
export class RelatedDeterminantSetComponent implements OnChanges {

  @ViewChild("lgModal") public lgModal;
  @Input() public relatedDeterminants: any;
  public relatedDeterminantValues: any[] = [];

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.pushToRelatedDeterminantDropDownValues(this.relatedDeterminants);
  }

  public ngOnInit() {
    this.pushToRelatedDeterminantDropDownValues(this.relatedDeterminants);
  }

  public pushToRelatedDeterminantDropDownValues(determinants: Determinant[]) {
    this.relatedDeterminantValues = [];
    this.relatedDeterminants.forEach((item) => {
      this.relatedDeterminantValues.push(item.id);
    });
  }

  public showModal() {
    this.lgModal.show();
  }

}
